import { render } from "./QRView.vue?vue&type=template&id=3a091746&ts=true"
import script from "./QRView.vue?vue&type=script&lang=ts"
export * from "./QRView.vue?vue&type=script&lang=ts"

import "./QRView.vue?vue&type=style&index=0&id=3a091746&lang=css"

import exportComponent from "/builds/kligmanbb/qr-medsafe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPageContainer});
